import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import {
  getAdminEmpresa, getFinanceiroAgencia, getFinanceiroCaixa,
  getFinanceiroEmpresa,
  getFiscalEmbarque,
  getGestorEmpresa,
  getOperadorEmpresa,
  getVendedorAgencia,
  PERFIL_ADMIN,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';

export class MenuFechamentoCaixa extends Component {

  possuiPerfilFinanceiroAgenciaEVendedorAgencia() {
    return validaPerfis([getFinanceiroAgencia(this.props.empresaSelecionada.id)])
      && validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)])
  }

  possuiPerfilVerAdminOuFinaceiroEmpresa() {
    return validaPerfis([PERFIL_ADMIN]) || validaPerfis([getFinanceiroEmpresa(this.props.empresaSelecionada.id)])
  }

  render () {
    return (
      <div className="area-home">
        <Titulo texto="Relatórios" urlRetorno="/"/>
        <div className="vx-menu-grid">
          <Autorizacao perfisPermitidos={[
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            getFinanceiroEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            PERFIL_ADMIN]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <Link to="/painel-resumo-financeiro" className="vx-menu-card">
              <div className="vx-menu-card-icon"><RequestQuoteOutlinedIcon /></div>
              <div className="vx-menu-card-label">Resumo Financeiro</div>
            </Link>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id),
            getFinanceiroEmpresa(this.props.empresaSelecionada.id),
            PERFIL_ADMIN]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <Link to="/painel-relatorio-itinerarios" className="vx-menu-card">
              <div className="vx-menu-card-icon"><SignpostOutlinedIcon /></div>
              <div className="vx-menu-card-label">Itinerários</div>
            </Link>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[getFinanceiroEmpresa(this.props.empresaSelecionada.id),
            PERFIL_ADMIN]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <Link to="/painel-relatorio-gerencial" className="vx-menu-card">
              <div className="vx-menu-card-icon"><SignpostOutlinedIcon /></div>
              <div className="vx-menu-card-label">Relatório Gerencial</div>
            </Link>
          </Autorizacao>
          {(this.possuiPerfilFinanceiroAgenciaEVendedorAgencia() || this.possuiPerfilVerAdminOuFinaceiroEmpresa()) && (
            <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
              getFinanceiroEmpresa(this.props.empresaSelecionada.id),
              getFinanceiroAgencia(this.props.empresaSelecionada.id),
              PERFIL_ADMIN]}
              empresaSelecionada={this.props.empresaSelecionada}>
              <Link to="/painel-relatorio-gerencial-agencia" className="vx-menu-card">
                <div className="vx-menu-card-icon"><SignpostOutlinedIcon /></div>
                <div className="vx-menu-card-label">Relatório Gerencial Agência</div>
              </Link>
            </Autorizacao>
          )}
        </div>
      </div>
    );
  }
}
export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication
  }
}



export default withRouter(connect(mapStateToProps, {})(MenuFechamentoCaixa));
